<template>
    <div>
        <img :src="url" alt="" style="width:100%">
    </div>
</template>
<script>
export default {
   data(){
      return{
          url:''
      }
       
   },
   mounted(){
       this.url=this.$route.query.url;
       document.title=this.$route.query.name;
   }
}
</script>



// WEBPACK FOOTER //
// src/pages/meeting/image.vue